<button
  class="fixed inset-0 bg-black bg-opacity-80 z-modal-overlay"
  type="button"
  (click)="handleButtonClick()"
>
  <span class="sr-only">Close dialog</span>
</button>
